'use strict';

const React = require('react');
const ReactDOM = require('react-dom');

const User = require('../global/models/User');
const enabler = require('../global/utils/enabler.es');
const abExperiments = require('../global/abExperiments.es');

const {ResponsiveHero, ResponsiveCollection} = require('./components/carousels');
const personalizationHelpers = require('./helpers/personalizationHelpers.es');
const introductionHelper = require('../components/Introduction/introduction-helper.es');
const tradeWelcomeMessageHelper = require('../global/tradeWelcomeMessageHelper.es');
const tracking = require('./helpers/tracking.es');

exports.init = function (options = {}) {
    const {data, context} = options;

    tracking.init({data});

    // Hero carousel
    if (data.heroItems) {
        const flattenItems = data.heroItems
            .map(a => a.items)
            .reduce((a, b) => {
                return a.concat(b);
            }, []);

        ReactDOM.render(
            React.createElement(ResponsiveHero, {
                items: flattenItems
            }),
            document.querySelector('.js-hero-carousel')
        );
    }

    // Collections carousel
    if (data.collectionItems) {
        ReactDOM.render(
            React.createElement(ResponsiveCollection, {
                items: data.collectionItems
            }),
            document.querySelector('.js-collections-carousel')
        );
    }

    // Personalization
    const personalizationCarouselContainer = document.querySelector('.js-personalization-container');
    const carouselOptions = {
        context,
        container: personalizationCarouselContainer
    };

    if (personalizationCarouselContainer) {
        if (abExperiments.homePageRecommendations) {
            abExperiments.homePageRecommendations
                .then(() => {
                    personalizationHelpers.render(Object.assign({
                        dataKeys: [personalizationHelpers.ATTRIBUTE_KEY, personalizationHelpers.CATEGORY_KEY],
                        categoryLevels: 3
                    }, carouselOptions));
                })
                .catch(() => {
                    personalizationHelpers.render(carouselOptions);
                });

            setTimeout(function () {
                abExperiments.homePageRecommendations.reject();
            }, 800);
        } else {
            personalizationHelpers.render(carouselOptions);
        }

        User.getCurrentUser().once('login:change', () => personalizationHelpers.render(carouselOptions));
    }

    // Trade welcome message
    tradeWelcomeMessageHelper.initWelcomeMessage(options.context);

    // Initialize introduction banner
    introductionHelper.init({
        context: options.context,
        isEnabled: enabler.isEnabled('brand_introduction')
    });
};



// WEBPACK FOOTER //
// ./assets/js/home/base.es.js